import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output
} from '@angular/core';

import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ChangePasswordPayload } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { ImmomioButtonComponent } from '@immomio/ui/button';
import { PasswordComponent } from '../form/controls/password/password.component';
import { matchControlValidatorFactory } from '../form/controls/validation/validators';
import { passwordValidators } from '../form/controls/validation/password-validators';

@Component({
  selector: 'app-set-password-form',
  templateUrl: './set-password-form.component.html',
  styleUrls: ['./set-password-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    PasswordComponent,
    TranslatePipe,
    ImmomioButtonComponent
  ]
})
export class SetPasswordFormComponent {
  private formBuilder = inject(FormBuilder);
  readonly ctaButtonLabel = input<string>(undefined);
  readonly isSaving = input<boolean>(undefined);
  readonly submitPassword = output<ChangePasswordPayload>();

  public form = this.formBuilder.group({
    password: [
      '',
      passwordValidators(
        matchControlValidatorFactory('confirmedPassword', true)
      )
    ],
    confirmedPassword: [
      '',
      passwordValidators(matchControlValidatorFactory('password', true))
    ]
  });

  public setPassword(): void {
    this.submitPassword.emit(this.form.getRawValue());
  }
}
